module.exports = __webpack_public_path__ + "static/media/Cats eyes 06_SVENSKA-mixdown.7f7d9f70.mp3";